var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ng-click=\"$ctrl.goToAll()\" ui-sref=\"batch.all\">\n<a translate=\"batch.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"batch.create\">\n<a translate=\"batch.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n<ui-view>\n</ui-view></ui-view></div>\n</div>\n</div>";
var id1="batch.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/batch/batch.html
// module id = 2646
// module chunks = 1